import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

// Public
export const fetchPlaces = (params = {}) => client.get("/places", { params }).then((r) => r.data);
export const fetchPlace = (slug) => client.get(`/places/${slug}`).then((r) => r.data);
export const fetchMeta = () => client.get("/meta").then((r) => r.data);

// Early-access signups
export const createSignup = (email, source = "website") =>
  client.post("/signups", { email, source }).then((r) => r.data);
export const fetchSignups = (token) =>
  client.get("/signups", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

// Admin
const authHeader = (token) => ({ headers: { "X-Admin-Token": token } });
export const adminLogin = (passcode) => client.post("/admin/login", { passcode }).then((r) => r.data);
export const adminFetchAll = (token) =>
  client.get("/places", { params: { include_hidden: true }, ...authHeader(token) }).then((r) => r.data);
export const adminCreate = (token, data) => client.post("/places", data, authHeader(token)).then((r) => r.data);
export const adminUpdate = (token, id, data) => client.put(`/places/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminToggle = (token, id, visible) =>
  client.patch(`/places/${id}/visibility`, { visible }, authHeader(token)).then((r) => r.data);
export const adminDelete = (token, id) => client.delete(`/places/${id}`, authHeader(token)).then((r) => r.data);
export const reorderPlaces = (token, ids) => client.post("/places/reorder", { ids }, authHeader(token)).then((r) => r.data);
export const fetchGuides = () => client.get("/guides").then((r) => r.data);
export const adminFetchGuides = (token) => client.get("/guides", { params: { include_hidden: true }, ...authHeader(token) }).then((r) => r.data);
export const adminCreateGuide = (token, data) => client.post("/guides", data, authHeader(token)).then((r) => r.data);
export const adminUpdateGuide = (token, id, data) => client.put(`/guides/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteGuide = (token, id) => client.delete(`/guides/${id}`, authHeader(token)).then((r) => r.data);
